module.exports = new __parcel__URL__("puppy4.516ccd1c.png").toString();